import { Box, Button, CircularProgress, Divider, Paper, Stack, Typography } from "@mui/material";
import { DownloadRounded } from "@mui/icons-material";

/**
 * Shared filter card for Custom Queries pages.
 * Children are the filter fields; the submit action sits below the grid.
 */
const QueryFilterPanel = ({
	children,
	onSubmit,
	loading = false,
	submitLabel = "Download",
	submitIcon,
	hint,
}) => {
	return (
		<Paper
			component="form"
			onSubmit={onSubmit}
			elevation={0}
			sx={{
				// CssBaseline is not mounted app-wide, so Paper needs its own border-box
				boxSizing: "border-box",
				maxWidth: "100%",
				overflow: "hidden",
				borderRadius: 2,
				border: "1px solid",
				borderColor: "divider",
				bgcolor: "background.paper",
			}}>
			<Stack sx={{ p: { xs: 2, md: 2.5 } }} spacing={2}>
				{hint ? (
					<Typography variant="body2" color="text.secondary">
						{hint}
					</Typography>
				) : null}

				{/* auto-fill keeps columns readable at any width instead of squeezing fixed breakpoints */}
				<Box
					sx={{
						display: "grid",
						gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 220px), 1fr))",
						columnGap: 2,
						rowGap: 1.5,
						alignItems: "end",
					}}>
					{children}
				</Box>
			</Stack>

			<Divider />

			<Box sx={{ display: "flex", justifyContent: "flex-end", px: { xs: 2, md: 2.5 }, py: 1.5 }}>
				<Button
					variant="contained"
					type="submit"
					disabled={loading}
					startIcon={
						loading ? <CircularProgress color="inherit" size={18} /> : submitIcon ?? <DownloadRounded />
					}
					sx={{
						minWidth: 150,
						height: 40,
						px: 2.5,
						borderRadius: 1.5,
						textTransform: "none",
						fontWeight: 600,
						boxShadow: "none",
						"&:hover": { boxShadow: "none" },
					}}>
					{loading ? "Working…" : submitLabel}
				</Button>
			</Box>
		</Paper>
	);
};

export default QueryFilterPanel;
